<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">
        สิทธิ์ของพนักงาน
      </span>
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!employeePolicyFormShow">
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            placeholder="รหัส - ชื่อพนักงาน"
            @input="handleSearch"
          ></v-text-field>
          <!-- <v-autocomplete
            style="width: 256px;"
            class="white mr-2"
            v-model="filterOrganization"
            :items="organizations"
            item-text="title_th"
            item-value="organization_uuid"
            label="หน่วยงาน"
            prepend-inner-icon="mdi-filter-variant"
            clearable
            dense
            outlined
            hide-details
            @change="handleFilterOrganization"
          ></v-autocomplete>
          <v-autocomplete
            style="width: 256px;"
            class="white"
            v-model="filterPosition"
            :items="positions"
            item-text="title_th"
            item-value="position_uuid"
            label="ตำแหน่ง"
            prepend-inner-icon="mdi-filter-variant"
            clearable
            dense
            outlined
            hide-details
            @change="handleFilterPosition"
          ></v-autocomplete> -->
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :headers="headers"
      :items="employeePolicyList"
      :options.sync="options"
      :server-items-length="totalEmployeePolicyList"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.image_profile="{ item }">
        <v-list-item-avatar
          rounded
          size="36"
          class="my-1 mx-0"
          style="cursor: pointer"
          @click.stop="handleShowPreviewImg(item.url_photo_identifier)"
        >
          <v-img
            v-if="item.url_photo_identifier"
            :src="item.url_photo_identifier"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="blue lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-avatar v-else tile color="grey lighten-4" size="36">
            <v-icon color="grey lighten-1" large> mdi-account </v-icon>
          </v-avatar>
        </v-list-item-avatar>
      </template>
      <template v-slot:item.profile_data="{ item }">
        <v-list-item class="px-0" two-line>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.firstname_th }} {{ item.lastname_th }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ item.organization.title_th }} - {{ item.position.title_th }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-slot:item.policy="{ item }">
        <span v-if="item.personal_policy_uuid"
          ><v-chip
            color="cyan"
            text-color="white"
            small
            class="mr-2 my-1"
            :key="item.employee_uuid"
          >
            ส่วนตัว
          </v-chip></span
        >
        <span v-if="item.roles && item.roles.length > 0">
          <v-chip
            small
            class="mr-2 my-1"
            v-for="item in item.roles.slice(0, 3)"
            :key="item.role_uuid"
          >
            {{ item.title }}
          </v-chip>
          <v-chip outlined small v-if="item.roles.length > 3"
            >+ {{ item.roles.length - 3 }}</v-chip
          >
        </span>
        <span v-else>-</span>
      </template>
    </v-data-table>
    <EmployeePolicyForm
      :formShow="employeePolicyFormShow"
      :employeePolicy="employeePolicy"
      :employeePolicyInit="employeePolicyInit"
      @isEmployeePolicyDataChange="handleEmployeePolicyFormDataChange"
      @formActionCompleted="handleEmployeePolicyFormActionCompleted"
      @onReset="handleEmployeePolicyFormReset"
      @updateEmployeePolicyRoles="handleUpdateEmployeePolicyRoles"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-container>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'

import ConfirmDialog from '@/components/ConfirmDialog.vue'
import EmployeePolicyForm from '@/views/employee-policy/EmployeePolicyForm.vue'

export default {
  components: {
    ConfirmDialog,
    EmployeePolicyForm,
  },
  data() {
    return {
      cancelTokenSource: null,
      loading: false,
      options: {},
      sortBy: ['employee_code'],
      sortDesc: [false],
      search: '',
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      headers: [
        {
          text: '##',
          align: 'center',
          sortable: false,
          value: 'image_profile',
          width: '5%',
        },
        {
          text: 'รหัสพนักงาน',
          value: 'employee_code',
          width: '15%',
        },
        {
          text: 'ชื่อ - หน่วยงาน - ตำแหน่ง',
          sortable: false,
          value: 'profile_data',
          width: '40%',
        },
        {
          text: 'สิทธิ์ - บทบาท',
          sortable: false,
          value: 'policy',
          width: '40%',
        },
      ],
      employeePolicyFormShow: false,
      employeePolicy: {
        organization: {},
        position: {},
      },
      employeePolicyInit: {
        organization: {},
        position: {},
      },
      isEmployeePolicyDataChange: false,
      timeout: null,
    }
  },
  watch: {
    options: {
      handler() {
        this.getEmployeePolicyList()
      },
      deep: true,
    },
  },
  computed: {
    employeePolicyList() {
      return this.$store.state.employeePolicy.employeePolicyList
    },
    totalEmployeePolicyList() {
      return this.$store.state.employeePolicy.totalEmployeePolicyList
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'สิทธิ์ของพนักงาน',
        disabled: true,
      },
    ])
  },
  methods: {
    ...mapActions({
      fetchEmployeePolicyList: 'employeePolicy/fetchEmployeePolicyList',
    }),
    handleUpdateEmployeePolicyRoles(employeePolicy) {
      this.employeePolicy = JSON.parse(JSON.stringify(employeePolicy))
      this.employeePolicyInit = JSON.parse(JSON.stringify(employeePolicy))

      this.getEmployeePolicyList()
    },
    handleSearch() {
      this.loading = true
      this.getEmployeePolicyListBySearch()
    },
    getEmployeePolicyListBySearch: _.debounce(function () {
      this.options.page = 1
      this.getEmployeePolicyList()
    }, 1000),
    async getEmployeePolicyList() {
      try {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options

        const sortParams = sortBy
          .map((field, i) => `${field}:${sortDesc[i] ? 'desc' : 'asc'}`)
          .join(',')

        if (this.cancelTokenSource) {
          this.cancelTokenSource.abort()
        }

        const controller = new AbortController()
        this.cancelTokenSource = controller

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            dpc: 'employee-policy-to-list-employee-policy',
            search: this.search || undefined,
            sort: sortParams || undefined,
            is_active: true,
            limit: itemsPerPage,
            offset: (page - 1) * itemsPerPage,
          },
          signal: controller.signal,
        }

        this.loading = true
        await this.fetchEmployeePolicyList(payload)
        this.loading = false
      } catch (error) {
        if (error.name === 'CanceledError') {
          // Request was cancelled, do nothing
          return
        }

        this.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    classRowSelected(row) {
      if (this.employeePolicy.employee_uuid === row.employee_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.employeePolicy.employee_uuid === row.employee_uuid) {
        this.employeePolicyFormShow = false
        this.employeePolicy = { organization: {}, position: {} }
        this.employeePolicyInit = { organization: {}, position: {} }
      } else {
        this.employeePolicyFormShow = true
        this.employeePolicy = { ...row }
        this.employeePolicyInit = { ...row }
      }
    },
    handleRowSelected(row) {
      if (this.isEmployeePolicyDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleEmployeePolicyFormDataChange(value) {
      this.isEmployeePolicyDataChange = value
    },
    handleEmployeePolicyFormReset() {
      this.employeePolicy = { ...this.employeePolicyInit }
    },
    handleEmployeePolicyFormActionCompleted() {
      this.employeePolicy = { organization: {}, position: {} }
      this.employeePolicyInit = { organization: {}, position: {} }
      this.employeePolicyFormShow = false
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.employeePolicyFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEmployeePolicyDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    if (this.cancelTokenSource) {
      this.cancelTokenSource.abort()
    }
    clearTimeout(this.timeout)
  },
}
</script>
